export default "__VITE_ASSET__CBjCHGfy__"